module.exports = __webpack_public_path__ + "static/media/featured_img1.86949dc5.png";